import { useState } from "react";
import { faqItems } from "@/mocks/news";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">关于吃瓜，你可能想问</h2>
          <p className="mt-3 text-sm text-foreground-700">
            关于瓜场的定位、内容原则、信源核实与投稿方式，这里都能找到答案。
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-3xl space-y-3">
          {faqItems.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-[15px] font-medium text-foreground-950 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i
                      className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base w-4 h-4 flex items-center justify-center`}
                    ></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}